import { useState } from 'react';
import { type ChatMessageItem } from '../../../components/chat/ChatMessage';
import { createFeedback } from '../../../services/api/adminFeedback';
import type { AdminFeedbackType } from '../../../types/feedback';

export const usePlaygroundFeedback = (messages: ChatMessageItem[]) => {
  const [feedbackModal, setFeedbackModal] = useState<{
    type: AdminFeedbackType;
    messageId: string;
    userMessage: string;
    assistantAnswer: string;
  } | null>(null);

  const handleAdminFeedback = (type: AdminFeedbackType, assistantMsg: ChatMessageItem) => {
    const lastUserMsg = [...messages].reverse().find((m) => m.role === 'user');
    setFeedbackModal({
      type,
      messageId: assistantMsg.id,
      userMessage: lastUserMsg?.content ?? '',
      assistantAnswer: assistantMsg.content,
    });
  };

  const handleCloseFeedbackModal = () => {
    setFeedbackModal(null);
  };

  const handleSubmitFeedback = async (payload: Parameters<typeof createFeedback>[0]) => {
    await createFeedback(payload);
  };

  return { feedbackModal, handleAdminFeedback, handleCloseFeedbackModal, handleSubmitFeedback };
};
